<template>
  <div>
    <div v-if="disableForm && canConsult">
      <div class="custom-search d-flex mb-2">
        <b-button
          v-if="canInsert"
          class="justify-content-start"
          variant="primary"
          @click="inserirHistorico()"
        >
          Alterar Tipo de Registro
        </b-button>
      </div>
      <div class="custom-search d-flex justify-content-end mb-2">
        <b-badge variant="primary" style="font-size: 16px">
          Registro Atual: {{ registroAtual }}
        </b-badge>
      </div>
      <b-row>
        <b-col md="12">
          <div class="justify-content-center mb-2">
            <h4>Histórico do Tipo de Registro</h4>
          </div>
        </b-col>
      </b-row>
      <vue-good-table
        :columns="columns"
        :rows="listaHistorico"
        :rtl="direction"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      />
    </div>
    <div v-else>
      <validation-observer ref="form">
        <b-form @submit.prevent>
          <fieldset :disabled="!canFormEdit">
            <b-row>
              <!-- nome -->
              <b-col cols="12" lg="12">
                <validation-provider
                  #default="{ errors }"
                  name="descricao"
                  rules="required"
                >
                  <b-form-group label="Descrição" label-for="v-descricao">
                    <b-form-input
                      id="v-descricao"
                      v-model="TipoRegistroPlace.descricao"
                      :state="errors.length > 0 ? false : null"
                      placeholder="descrição"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- situacaoRegistro -->
              <b-col cols="12" lg="12">
                <b-form-group label="Tipo Registro" label-for="v-tipoRegistro">
                  <v-select
                    v-model="TipoRegistroPlace.tipoRegistro"
                    label="nome"
                    :options="comboTypesRegister"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </fieldset>
          <b-row class="mt-1">
            <!-- submit and reset -->
            <b-col cols="12">
              <ButtonsFormVue
                :permission-insert="canInsert"
                :permission-edit="canUpdate"
                :permission-delete="canDelete"
                :disable-form="false"
                @save="save()"
                @cancel="cancel()"
              />
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
} from "bootstrap-vue";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import store from "@/store/index";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    VueGoodTable,
    BBadge,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      registroAtual: null,
      listaHistorico: [],
      disableForm: true,
      TipoRegistroPlace: {
        descricao: "",
        registro: {
          id: null,
        },
        tipoRegistro: {
          id: null,
        },
      },
      columns: [
        {
          label: "Tipo de Registro",
          field: "tipoRegistro.nome",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Data",
          field: this.fieldFn,
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd/MM/yyyy",
        },
      ],
      pageLength: 10,
      dir: false,
      required,
    };
  },
  computed: {
    ...mapState("associantesAdministrativeModule", {
      fullAssociante: (state) => state.fullAssociante,
      comboTypesRegister: (state) => state.comboTypesRegister,
    }),
    canInsert() {
      return this.verificarPermissao("ROLE_HISTORICO_TIPO_REGISTRO_INSERIR");
    },
    canUpdate() {
      return this.verificarPermissao("ROLE_HISTORICO_TIPO_REGISTRO_ATUALIZAR");
    },
    canDelete() {
      return this.verificarPermissao("ROLE_HISTORICO_TIPO_REGISTRO_DELETAR");
    },
    canConsult() {
      return this.verificarPermissao("ROLE_HISTORICO_TIPO_REGISTRO_CONSULTAR");
    },
    canFormEdit() {
      if (this.disableForm) return false;
      return this.canInsert;
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  watch: {
    fullAssociante(val) {
      if (val && val.tipoRegistro) {
        this.registroAtual = val.tipoRegistro.nome;
      }
    },
  },
  mounted() {
    if (this.canConsult) {
      this.getHistoricoTipoRegistro();
    }
    if (this.fullAssociante && this.fullAssociante.tipoRegistro) {
      this.registroAtual = this.fullAssociante.tipoRegistro.nome;
    }
  },
  methods: {
    getHistoricoTipoRegistro() {
      this.$store
        .dispatch(
          "associantesAdministrativeModule/getHistoricoTipoRegistro",
          this.$route.params.id,
        )
        .then((response) => {
          this.listaHistorico = response.data;
        });
    },
    inserirHistorico() {
      this.TipoRegistroPlace = {
        descricao: "",
        registro: {
          id: null,
        },
        tipoRegistro: {
          id: null,
        },
      };
      this.TipoRegistroPlace.registro.id = this.$route.params.id;
      this.disableForm = false;
    },
    cancel() {
      this.TipoRegistroPlace = {
        descricao: "",
        registro: {
          id: null,
        },
        tipoRegistro: {
          id: null,
        },
      };
      this.disableForm = true;
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.$store
            .dispatch(
              "associantesAdministrativeModule/setMudarTipoRegistro",
              this.TipoRegistroPlace,
            )
            .then((response) => {
              this.showMessageSuccess("Editar", "Editado com sucesso!");
              this.registroAtual = response.data.tipoRegistro.nome;
              this.TipoRegistroPlace.tipoRegistro = response.data.tipoRegistro;
              this.getHistoricoTipoRegistro();
              this.disableForm = true;
            })
            .catch((error) => {
              const errorMsg =
                error.response?.data?.message || "Falha ao Editar";
              this.MensagemError("Falha ao Editar", errorMsg);
            });
        }
      });
    },
    fieldFn(rowObj) {
      if (rowObj.dataCriacao) {
        let data = rowObj.dataCriacao.substring(0, 10);
        data = data.toLocaleString();
        return data;
      }
      return rowObj.dataCriacao;
    },
  },
};
</script>
